import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalProvider } from '../../providers/global/global';
import { HttpParams, HttpClient } from '@angular/common/http';
import{ ThankYouPage } from '../../pages/thank-you/thank-you';
/**
 * Generated class for the RejectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-reject',
  templateUrl: 'reject.html',
})
export class RejectPage {

  validation_messages = {
    'reject': [
      { type: 'required', message: 'Please insert reject reason.' },
    ]
  }
  clickedemptyreject: boolean = false;
  rejectForm:any;
  myRows: number = 10;

  constructor(public navCtrl: NavController, public navParams: NavParams,public global: GlobalProvider, public http: HttpClient) {

    this.rejectForm = new FormGroup({
      "reject": new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.-]+[a-zA-Z0-9_.-]+$')
      ]))
    })




  }
  checktext(str: string, typet: string) {
    if (str.length > 2) {
      if (typet == 'reject')
        this.clickedemptyreject = false;
    }
  }
  
  rejectBtn(rejectreason: string){

    if(rejectreason){
        this.global.createLoader();
        this.global.loading.present().then((result) => {


        var p:any={};
        p.id = this.global.timesheetid;
        p.entity = 'Timesheet';
        p.field="RejectReason";
        p.value = rejectreason;
        p.portal = this.global.getPortalID();
        p.contacttype = this.global.contacttype;

        const params = new HttpParams()
        .set('j',JSON.stringify(p))


        this.http.post('timesheets/timesheet_reject/',params).subscribe(

          (data) => {

              this.global.loading.dismiss();
              var res_reject : any = data;
                if(res_reject.result==true){
                  this.navCtrl.push(ThankYouPage,{rejection:"1"});
                }
            },
            error => {
              alert(error);
            }
          );

        }).catch((err) => {

      });

    } else {
      this.clickedemptyreject  = true;
    }
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad RejectPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/reject/reject.ts